import { createFileRoute } from '@tanstack/react-router'
import { MCPInstall } from '~/components/MCPInstall'
import { DocsLayout } from '~/components/DocsLayout'

export const Route = createFileRoute('/docs/mcp/')({
    component: MCPPage,
})

function MCPPage() {
    return (
        <DocsLayout>
            <div className="h-full overflow-y-auto">
                <div className="p-6 max-w-4xl animate-fade-in">
                    <header className="mb-6">
                        <h1 className="text-2xl font-bold text-white mb-2">🧩 MCP Integration</h1>
                        <p className="text-slate-400">
                            Connect your AI coding assistant to access Legali documentation via the Model Context Protocol.
                        </p>
                    </header>

                    <MCPInstall />

                    <section className="mt-8 space-y-6">
                        <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-6">
                            <h2 className="text-lg font-semibold text-white mb-4">What is MCP?</h2>
                            <p className="text-slate-400 mb-4">
                                The Model Context Protocol (MCP) is an open standard that allows AI assistants to access external data and tools.
                                With MCP, your AI can:
                            </p>
                            <ul className="list-disc list-inside text-slate-400 space-y-2">
                                <li>Browse all documentation without opening a browser</li>
                                <li>Search across documentation files</li>
                                <li>List and track project tasks</li>
                                <li>Get real-time task status updates</li>
                            </ul>
                        </div>

                        <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-6">
                            <h2 className="text-lg font-semibold text-white mb-4">Available Capabilities</h2>
                            <div className="grid gap-4 md:grid-cols-2">
                                <div className="bg-slate-900/50 rounded-lg p-4">
                                    <h3 className="font-medium text-white mb-2">📚 Resources</h3>
                                    <p className="text-sm text-slate-400">Access documentation tree and read individual docs</p>
                                </div>
                                <div className="bg-slate-900/50 rounded-lg p-4">
                                    <h3 className="font-medium text-white mb-2">🔧 Tools</h3>
                                    <p className="text-sm text-slate-400">list_tasks, get_task, search_docs</p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-6">
                            <h2 className="text-lg font-semibold text-white mb-4">Endpoint</h2>
                            <code className="block bg-slate-900 rounded-lg p-4 text-sm text-slate-300 font-mono">
                                POST https://legali-docs.pages.dev/api/mcp
                            </code>
                            <p className="text-sm text-slate-500 mt-2">
                                Uses JSON-RPC 2.0 with Streamable HTTP transport
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </DocsLayout>
    )
}
